import { CodeNormalizer } from "./CodeNormalizer.interface";

export class UnderScoreLanguageCodeNormalizer implements CodeNormalizer {
    readonly languageCode: string

    constructor(languageCode?: string) {
        this.languageCode = languageCode;
    }
    getNormalizerCode(): string {
        const pattern = /_/g;
        if (this.languageCode?.match(pattern).length) {
            return this.languageCode.replace(pattern, '-')
        }
        return this.languageCode;
    }
}